module.exports = __webpack_public_path__ + "img/Imagecancleicon.6a0cf8aa.svg";